import React, { FunctionComponent } from 'react';

import classname from '@search/classname/src';

import { Badge as DSBadge } from '@vtblife/uikit';
import { BadgeColor, BadgeProps } from '@vtblife/uikit/dist/components/badge/types';

import { Badge, IBadgeProps } from '../index';

import './styles.css';

type NewBuildingClass = 'BUSINESS' | 'COMFORT' | 'COMFORT_PLUS' | 'ECONOMY' | 'ELITE' | 'UNKNOWN'

const NEW_BUILDING_CLASS_COLORS: Record<NewBuildingClass, BadgeColor> = {
    BUSINESS: 'purple',
    COMFORT: 'turquoise',
    COMFORT_PLUS: 'green',
    ECONOMY: 'orange',
    ELITE: 'black',
    UNKNOWN: 'black'
};

export interface NewBuildingClassBadgeProps extends IBadgeProps {
    className?: string;
    newBuildingClass: NewBuildingClass;
}

const cn = classname.bind(null, 'NewBuildingClassBadge');

export const NewBuildingClassBadge: FunctionComponent<NewBuildingClassBadgeProps> = ({
    size,
    children,
    className,
    newBuildingClass,
    ...rest
}) => {
    return (
        <Badge
            {...rest}
            className={cn(null, { class: newBuildingClass }, className)}
            textClassName={cn('text', { class: newBuildingClass })}
            noBottomMargin
        >
            {children}
        </Badge>
    );
};

export const NewBuildingClassDSBadge: FunctionComponent<Omit<BadgeProps, 'color'> & {
    newBuildingClass: NewBuildingClass;
}> = ({
    newBuildingClass,
    children,
    ...rest
}) => (
    <DSBadge
        {...rest}
        color={NEW_BUILDING_CLASS_COLORS[newBuildingClass]}
    >
        {children}
    </DSBadge>
);
